//Create a new Personal Info object
export function createPersonalInfo() {
  const personalInfo = {
    title: "",
    fullName: "",
    race: "",
    gender: "",
    dob: "",
    age: "",
    countryOfBirth: "",
    countryOfNationality: "",
    maritalStatus: "",
    idType: "",
    idNumber: "",
    isPoliticallyExposed: "",

    mobilecountrycode: "",
    mobilephone: "",
    email: "",
    homecountrycode: "",
    homephone: "",
    officecountrycode: "",
    officephone: "",

    countryofresidence: "",
    postcode: "",
    blockno: "",
    unitno: "",
    streetname: "",
    buildingname: "",
    islanded: "",

    employmentstatus: "",
    employer: "",
    occupation: "",
    highesteducation: "",
    isFinancialBusiness: "",

    spokenEnglish: "",
    spokenMandarin: "",
    spokenMalay: "",
    spokenTamil: "",
    spokenOthers: "",

    writtenEnglish: "",
    writtenMandarin: "",
    writtenMalay: "",
    writtenTamil: "",
    writtenOthers: "",
  };

  return personalInfo;
}
